export class QuantityAdjusterMultibuy extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['input', 'step']
  }

  setupListeners () {
    super.setupListeners()

    this.oldValue = 0
    this.onStepClick = this.onStepClick.bind(this)

    this.els.step.elements.forEach(step => {
      this.listeners.add(step, 'click', this.onStepClick)
    })
  }

  /**
   * @param {Event} e
   *
   * @returns {void}
   */
  onStepClick (e) {
    // Update the hidden quantity input value.
    this.target = e.target

    if (e.target !== this.els.step.element) {
      this.target = e.target.closest(
        '[data-quantity-adjuster-multibuy-el="step"]',
      )
    }

    if (!this.target?.dataset?.quantity) return

    this.updateClasses()
    this.updateValues()
  }

  /**
   * @returns {void}
   */
  updateValues () {
    // Update the quantity value in all inputs.
    this.oldValue = this.value
    this.value = Number(this.target.dataset.quantity)
    this.percentage = Number(this.target.dataset.discount)

    this.handleValueChangeSideEffects(this.value)
  }

  /**
   * @returns {void}
   */
  updateClasses () {
    this.els.step.elements.forEach(el => {
      el.classList.remove('qty-Multibuy_Step-active')
    })

    this.target.classList.add('qty-Multibuy_Step-active')
  }

  /**
   * @param {Number} val
   *
   * @returns {void}
   */
  handleValueChangeSideEffects (val) {
    this.els.input.elements.forEach(input => {
      input.value = val.toString()
    })

    this.dispatchEvent(
      new CustomEvent(window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE, {
        detail: {
          oldValue: this.oldValue,
          value: val,
        },
        bubbles: true,
      }),
    )
  }
}

if (!customElements.get('quantity-adjuster-multibuy')) {
  customElements.define('quantity-adjuster-multibuy', QuantityAdjusterMultibuy)
}
